<mat-dialog-content class="mat-typography">
    <h2>Confirmation</h2>
    <p>
        {{ confirmationMessage }}
    </p>
</mat-dialog-content>


<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="false">Annuler</button>
    <button mat-button [mat-dialog-close]="true" [color]="'primary'">Confirmer</button>
</mat-dialog-actions>
